export default ((_ref) => {
  var {
    id,
    el,
    payload,
    isCookieDebug
  } = _ref;
  var {
    data,
    fn
  } = payload;
  var eventType = fn !== null && fn !== void 0 ? fn : 'track-event';
  if (process.client && !!isCookieDebug) console.info('generic-tracking ', {
    id,
    el,
    data
  });
  if (window && window.mdm_events) window.mdm_events(id, el, eventType, data);
});